// discountHelpers.js

import { Trans } from "react-i18next";

export function getOfferProps(campaignData) {

  const alternativeOffer= campaignData?.alternativeOffer;
  const orderData=campaignData?.orderData  
  const variantDiscountData = alternativeOffer?.variantDiscountData;
  const discountData = variantDiscountData?.discountData;
  const isDiscountApplied = variantDiscountData?.isDiscountApplied;
  const prevPrice = variantDiscountData?.grossPrice.toFixed(2);
  const newPrice = isDiscountApplied ? variantDiscountData?.discountedPriceAfterConversion.toFixed(2) : prevPrice;
  const currencySymbol = variantDiscountData?.currencySymbol || variantDiscountData?.baseCurrencySymbol;
  const type= discountData?.type
  const discountValue = (type === "Percentage") ? (discountData?.amount + "%") : (type === "SetNewPrice") ? (currencySymbol + (prevPrice - newPrice)) : (type === "FixedDiscount") ? (currencySymbol + discountData?.amount) : "";
  const frequencyInMonths = discountData?.numberOfPayments;
  const freqDescription = variantDiscountData?.cccFrequencyShortDescription  ? `/${variantDiscountData?.cccFrequencyShortDescription}` : "" ;
  const showAddedTax = !variantDiscountData?.isTaxFixed && variantDiscountData?.vatApplicationMode === "FixedNet";
  const newPriceValue = currencySymbol + newPrice;
  const prevPriceValue = currencySymbol + prevPrice;
 
  const frequencyText = (
    <Trans
      i18nKey="retentionoffer.frequencystring"
      values={{
        newPrice,
        prevPrice,
        months: frequencyInMonths,
        freq: freqDescription,
        symbol: currencySymbol,
      }}
    />
  );

  const subsName = variantDiscountData?.displayName || variantDiscountData?.name;
  const description = discountData?.description || variantDiscountData?.description;
  const variantId = variantDiscountData?.variantId;
  const discountId = discountData?.discountID;
  const cardNumber = orderData?.creditCardNumber;
  const accNumber = orderData?.accountNumber;
  const accountNumber = accNumber.slice(-3);

  const cardTypeName = orderData?.creditCardTypeName;
  const startDate = getFormattedDate(orderData?.newSubscriptionStartDate);
  const endingDate = getFormattedDate(orderData?.subscriptionEndDate);
  const userName = orderData?.userName;
  const offerHeading = alternativeOffer?.offerHeading;
  const offerIntro = alternativeOffer?.offerIntro;
  const paymentType = orderData?.paymentType


  return {
    variantDiscountData,
    discountData,
    isDiscountApplied,
    prevPrice,
    newPrice,
    discountValue,
    frequencyInMonths,
    freqDescription,
    showAddedTax,
    currencySymbol,
    frequencyText,
    subsName,
    description,
    variantId,
    discountId,
    cardNumber,
    cardTypeName,
    startDate,
    endingDate,
    userName,
    offerHeading,
    offerIntro,
    frequencyInMonths,
    newPriceValue,
    prevPriceValue,
    accountNumber,
    paymentType
  };
}


export const getFormattedDate=(date)=>{
    
    let [year, month, day] = date.split("T")[0].split("-");
    return `${day}/${month}/${year}`;
}

